import investorOrderByTemplate from './investorOrderBy.html';

const investorOrderBy = {

    bindings: {
        sortOrder: '<',
        onSort: '&'
    },

    template: investorOrderByTemplate,

    controller: function($scope, $state) {
        this.sortDirection = false;
        this.sortDirectionText = 'DESC';

        this.investorSortOrders = {
          'aum': 'AUM',
          'investorName': 'INVESTOR_ACCOUNT'
        };

        /*----------  Sorting order  ----------*/
        this.sort = () => {
            if (!angular.isUndefined(this.sortOrder)) {
                this.sortDirection = !this.sortDirection;
                this.sortDirectionText = this.sortDirection ? 'ASC' : 'DESC';
                this.onSort({ sortOrder: this.sortOrder, sortDirection: this.sortDirection });
            }
        };
    }
};

export default investorOrderBy;



/** WEBPACK FOOTER **
 ** ./src/app/directives/investorOrderBy/investorOrderBy.js
 **/